// TOKEN OPERATION
const storeAdminToken = (token) => {
  localStorage.setItem('token', token);
};

const getAdminToken = () => {
  return localStorage.getItem('token');
};


const removeAdminToken = () => {
  localStorage.removeItem('token');
};


const isAdminLoggedIn = () => {
  return !!localStorage.getItem('token');
};


// USER INFO OPERATION

const storeUserInfo = (user) => {
  localStorage.setItem('userInfo', JSON.stringify(user));
};

const getUserInfo = () => {
  let userInfo = localStorage.getItem('userInfo');
  return userInfo ? JSON.parse(userInfo) : null;
};

const removeUserInfo = () => {
  localStorage.removeItem('userInfo');
};

export { storeAdminToken, getAdminToken, removeAdminToken, isAdminLoggedIn, storeUserInfo, getUserInfo, removeUserInfo }